document.addEventListener('DOMContentLoaded', function() {
    const menu = document.querySelector('.main-header--nav-links');
    const links = menu.querySelectorAll('a, button');

    links.forEach(link => {
        link.addEventListener('keydown', function(event) {
            const currentItem = event.target.closest('li');
            const isDropdown = currentItem.classList.contains('dropdown');
            const isExpanded = currentItem.getAttribute('aria-expanded') === 'true';

            switch(event.key) {
                case 'Enter':
                    if (isDropdown) {
                        const dropdownMenu = currentItem.querySelector('.dropdown-wrap');
                        if (isExpanded) {
                            currentItem.setAttribute('aria-expanded', 'false');
                            dropdownMenu.setAttribute('aria-hidden', 'true');
                        } else {
                            currentItem.setAttribute('aria-expanded', 'true');
                            dropdownMenu.setAttribute('aria-hidden', 'false');
                        }
                    }
                    break;
                case 'ArrowDown':
                    if (isDropdown && !isExpanded) {
                        currentItem.setAttribute('aria-expanded', 'true');
                        currentItem.querySelector('.dropdown-wrap').setAttribute('aria-hidden', 'false');
                    }
                    break;
                case 'ArrowUp':
                    if (isDropdown && isExpanded) {
                        currentItem.setAttribute('aria-expanded', 'false');
                        currentItem.querySelector('.dropdown-wrap').setAttribute('aria-hidden', 'true');
                    }
                    break;
                case 'Escape':
                    if (isDropdown && isExpanded) {
                        currentItem.setAttribute('aria-expanded', 'false');
                        currentItem.querySelector('.dropdown-wrap').setAttribute('aria-hidden', 'true');
                    }
                    break;
            }
        });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(event) {
        links.forEach(link => {
            const currentItem = link.closest('li');
            const isDropdown = currentItem.classList.contains('dropdown');
            if (isDropdown) {
                const dropdownMenu = currentItem.querySelector('.dropdown-wrap');
                currentItem.setAttribute('aria-expanded', 'false');
                dropdownMenu.setAttribute('aria-hidden', 'true');
            }
        });
    });
});